<template>
  <div class="settings">
    <v-container fluid>
      <h1 class="mb-3">Agent Keyword Filter</h1>
      <div class="card-curvey">
        <v-combobox
          v-model="words"
          :items="[]"
          chips
          outline
          solo
          multiple
          @input="updateBadWords"
        >
          <template v-slot:selection="data">
            <v-chip
              :selected="data.selected"
              close
              @input="removeTerm(data.item)"
            >
              <strong>{{ data.item }}</strong
              >&nbsp;
            </v-chip>
          </template>
        </v-combobox>
      </div>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "badWords",
  data() {
    return {
      words: [],
    };
  },
  async mounted() {
    await this.getBadWords();
  },
  methods: {
    async getBadWords() {
      const response = await this.$http_session_manager.get(
        `/bad-words/${this.$store.state.bot.botId}`
      );

      if (response.data) {
        this.words = response.data.words;
      }
    },
    async updateBadWords() {
      await this.$http_session_manager.post(`bad-words`, {
        bot_id: this.$store.state.bot.botId,
        words: this.words,
      });
    },
    async removeTerm(term) {
      let index = this.words.indexOf(term);
      this.words.splice(index, 1);
      await this.updateBadWords();
    },
  },
};
</script>

<style scoped></style>
